import { AxiosError } from "axios";

import api from "../api";
import { IPaginatedParams } from "../interface";
import { returnResponse } from "../utils";

export const UnitService = {
  getAllPaginated: async (params: IPaginatedParams) => {
    try {
      const { pageNumber, pageSize, searchTerm, active } = params;
      const queryParams = new URLSearchParams({
        pageNumber: String(pageNumber),
        pageSize: String(pageSize),
      });
      if (active !== undefined && active !== 2) {
        queryParams.append("active", String(active));
      }
      if (searchTerm) {
        queryParams.append("searchTerm", searchTerm);
      }
      return await api.get<any>(
        `/v1/Place/GetAllByCustomer?${queryParams.toString()}`,
      );
    } catch (error) {
      console.error("Erro ao buscar as unidades:", error);
      throw error;
    }
  },

  GetAllByCustomerIdUserId: async (customerId: number, userId: number) => {
    try {
      const { data } = await api.get<any>(
        `/v1/Place/GetAllByCustomerIdUserId?customerId=${customerId}&userId=${userId}`,
      );

      return {
        status: true,
        data: data.data,
        message: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  post: async (unit: any) => {
    try {
      const body = {
        ...unit,
      };
      const { data } = await api.post<any>(`/v1/Place/Add`, body);

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      let severity: "error" | "warning" | "success";
      severity = "error";
      return {
        status: false,
        message: "Error",
        data: null,
        severity: severity,
      };
    }
  },

  put: async (unit: any) => {
    try {
      const body = {
        ...unit,
      };

      const { data } = await api.put<any>(`/v1/Place/Update`, body);

      return {
        status: true,
        data: data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      let severity: "error" | "warning" | "success";
      severity = "error";

      return {
        status: false,
        message: "Error",
        data: null,
        severity: severity,
      };
    }
  },

  delete: async (unitId: number) => {
    try {
      const { data } = await api.delete(`/v1/Place/Delete?id=${unitId}`);

      return {
        status: true,
        data: data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
};
